import React, { useRef } from 'react'
import { Button } from 'primereact/button'
import Store from 'store'
import './Login.scss'
import { getImageByUrl } from './utils/image'
import { Card } from 'primereact/card'
import { InputText } from 'primereact/inputtext'
import { useMutation as useMutationRQ } from 'react-query'
import { affiliateLogin } from './utils/login'
import { Toast } from 'primereact/toast'
import { useFormik } from 'formik'
import { classNames } from 'primereact/utils'
import { Password } from 'primereact/password'
import { IsEmailValid } from './utils/email'
import { useNavigate } from 'react-router-dom'

const Login = () => {
  const toast = useRef<any>()
  const brandEnv = process.env.REACT_APP_AFFILIATE_NAME
  const navigate = useNavigate()

  const showError = (msg: string) => {
    toast.current.show({
      severity: 'error',
      summary: 'Login Error',
      detail: msg,
      life: 5000,
    })
  }

  const loginFunc = (email: string, password: string) => {
    loginMutation({ email, password })
  }

  // login mutation
  const [loginMutation, { isLoading: loginLoading }] = useMutationRQ(affiliateLogin, {
    onSuccess: (data) => {
      if (data.statusCode || data.message) {
        showError(data.statusCode || data.message)
      }
    },
    onError: (er) => {
      console.log(er)
    },
    onSettled: (data) => {
      if (data.statusCode || data.message) {
        showError(data.statusCode || data.message)
      } else {
        Store.set('aff-id', data.id)
        Store.set('aff-tok', data.accessToken)
        Store.set('aff-name', data.email)
        navigate('/leads', { replace: true })
      }
    },
  })

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validate: (data: any) => {
      let errors: any = {}

      if (!data.email) {
        errors.email = 'Email is required.'
      } else if (!IsEmailValid(data.email)) {
        errors.email = 'Invalid email address. E.g. example@email.com'
      }

      if (!data.password) {
        errors.password = 'Password is required.'
      }

      return errors
    },
    onSubmit: (data) => {
      loginFunc(data.email, data.password)
    },
  })

  const isFormFieldValid = (name: 'email' | 'password') =>
    !!(formik.touched[name] && formik.errors[name])
  const getFormErrorMessage = (name: 'email' | 'password') => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>
  }

  return (
    <div
      style={{
        backgroundImage: getImageByUrl('login-background.jpg'),
      }}
      className="login__Container"
    >
      <Toast ref={toast} />
      <div className="p-grid p-justify-end p-align-center login__page__container">
        {brandEnv === 'ExpoDubai' ? (
          <div className="p-col-6">
            <img src="assets/ExpoDubai/images/brandIcon.png" alt="" width="450" />
          </div>
        ) : null}
        <div className="p-col-12 p-md-6 p-lg-3  login__card__container">
          {/* this is where the login card go */}
          <Card title="" className="p-shadow-10" style={{ width: '25em' }}>
            <form onSubmit={formik.handleSubmit} className="p-fluid">
              <div className="p-field p-mt-3">
                <label
                  htmlFor="email"
                  className={classNames({
                    'p-error': isFormFieldValid('email'),
                  })}
                >
                  Email*
                </label>
                <span className="p-float-label p-input-icon-right">
                  <i className="pi pi-envelope" />
                  <InputText
                    id="email"
                    name="email"
                    placeholder="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid('email'),
                    })}
                  />
                </span>
                {getFormErrorMessage('email')}
              </div>
              <div className="p-field p-mt-5">
                <label
                  htmlFor="password"
                  className={classNames({
                    'p-error': isFormFieldValid('password'),
                  })}
                >
                  Password*
                </label>
                <span className="p-float-label">
                  <Password
                    id="password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    feedback={false}
                    toggleMask
                    placeholder="password"
                    className={classNames({
                      'p-invalid': isFormFieldValid('password'),
                    })}
                  />
                </span>
                {getFormErrorMessage('password')}
                <Button className="p-mt-3" label="Login" loading={loginLoading} type="submit" />
              </div>
            </form>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default Login
